import React, { PureComponent } from "react";

interface ISVGPen2IconProps {
  className?: string;
  size?: string | number;
  fill?: string;
  onClick?: React.MouseEventHandler<SVGSVGElement>;
}

const style = {
  flex: "0 0 auto",
  cursor: "pointer"
};

export default class SVGPen2Icon extends PureComponent<
  ISVGPen2IconProps,
  {}
> {
  render() {
    const props = this.props;
    const { size, fill } = props;
    return (
      <svg
        {...props}
        preserveAspectRatio="xMidYMid meet"
        fontSize={size || 45}
        fill={fill || "currentColor"}
        style={style}
        width="32"
        height="32"
        viewBox="0 0 40 40"
      >
        {/* 검정색 연필 아이콘 (outline 스타일) */}
        <path
          fill="none"
          stroke="#8694B1"
          transform="translate(0.001 -0.001)" 
          
          // fill="none"
          // stroke="currentColor"
        />
      </svg>
    );
  }
}
